
export default function (Component) {
  Component.options.__source = "src/layout/no-header/components/components/menu-sub/index.vue"
}
